<template>
    <div>
        <div class="wrap1200 breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <router-view></router-view>
        <div v-if="$route.name === '资讯'" class="infoMain wrap1200">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="(item,index) in categoryName" :key="index" :label="item.name" :name="item.nickname">
                    <div v-if="articlelist.length != 0">
                        <div class="articleLIst" @click="goDetail(item.id)" v-for="(item,index) in articlelist">
                            <p>{{ item.title }}</p>
                            <span>{{ item.desc_content }}</span>
                        </div>
                    </div>
                    <div v-else>
                        <p style="text-align: center;">暂无数据</p>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import { getCategoryList,getCategoryName } from '../api/index'
export default {
    name: 'App',
    components: {
        Breadcrumb
    },
    data() {
        return {
            activeName: 'all',
            categoryName:[{
                name: '全部',
                id: 0,
                nickname:'all'
            }],
            tabIndex:0,
            articlelist:[],
            page:1
        };
    },
    created(){
        console.log(this.$route.name,'$route.name')
        this.getCategoryNameArr();
        this.getCategoryData();
    },
    methods: {
        handleClick(tab, event) {
            this.tabIndex = tab.index;
            this.getCategoryData(this.categoryName[tab.index].id);
        },
        getCategoryData(cid){
            console.log(cid,'cid');
            let params = {
                page: this.page,
				cid: cid ? cid : 0
            }
            getCategoryList(params).then(result => {
                let res = result.data;
                this.articlelist = res.data.data;
                console.log(this.articlelist,'this.articlelist')
            })
        },
        getCategoryNameArr(){
            getCategoryName().then(result => {
                let res = result.data;
                if(res.code == 1){
                    this.categoryName.push(...res.data);
                }
                console.log(res,'name')
            })
        },
        goDetail(id){
            this.$router.push({ path: '/service/articleDetail', query: { id: id} });
        }
    }
}
</script>
<style scoped>
.infoMain{
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px;
    min-height: 450px;
}
.wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}
.el-tabs__item.is-active{
    color: #EA4747;
}
.el-tabs__active-bar{
    background-color:#EA4747
}
.el-tabs__item:hover{
    color: #EA4747;
}
.articleLIst{
    border-radius: 15px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
    width: 80%;
    padding: 10px;
}
.articleLIst p{
    font-size: 16px;
    font-weight: bold;
}
.articleLIst span{
    font-size: 14px;
    color: #666666;
}
</style>


// WEBPACK FOOTER //
// src/views/service.vue